(function () {
  var TTL = 10 * 60 * 1000;

  function read(key) {
    try {
      var cached = JSON.parse(localStorage.getItem(key));
      if (cached && Date.now() - cached.time < TTL) return cached.value;
    } catch (e) {}
    return null;
  }

  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify({ time: Date.now(), value: value })); } catch (e) {}
  }

  function hash(text) {
    var value = 0;
    text = String(text);
    for (var i = 0; i < text.length; i++) value = (value * 31 + text.charCodeAt(i)) | 0;
    return value;
  }

  function choose(items, order, minRating, count) {
    var list = items.filter(function (item) { return (parseFloat(item.r) || 0) >= minRating; });
    list.sort(function (a, b) {
      if (order === 'top') {
        var byRating = (parseFloat(b.r) || 0) - (parseFloat(a.r) || 0);
        if (byRating) return byRating;
      }
      var dateA = a.d || '';
      var dateB = b.d || '';
      if (dateA !== dateB) {
        if (!dateA) return 1;
        if (!dateB) return -1;
        return dateA < dateB ? 1 : -1;
      }
      return hash(a.h) - hash(b.h);
    });
    return list.slice(0, count);
  }

  function fetchCards(pickUrl, handles) {
    var cache = read('rc-html-v2') || {};
    var missing = handles.filter(function (handle) { return !cache[handle]; });
    var request = missing.length
      ? fetch(pickUrl + encodeURIComponent(missing.join(',')), { credentials: 'same-origin' })
          .then(function (response) { return response.text(); })
          .then(function (text) { try { return JSON.parse(text); } catch (e) { return null; } })
          .then(function (data) {
            ((data && data.items) || []).forEach(function (item) { cache[item.h] = item.html; });
            write('rc-html-v2', cache);
          })
          .catch(function () {})
      : Promise.resolve();
    return request.then(function () {
      return handles.filter(function (handle) { return cache[handle]; }).map(function (handle) { return cache[handle]; });
    });
  }

  function whenSwiper(callback, tries) {
    if (window.Swiper) { callback(); return; }
    if ((tries || 0) > 100) return;
    setTimeout(function () { whenSwiper(callback, (tries || 0) + 1); }, 100);
  }

  function setup(root) {
    if (root.__rcReady) return;
    root.__rcReady = true;

    var wrapper = root.querySelector('[data-rc-wrapper]');
    var summary = root.querySelector('[data-rc-summary]');
    var nav = root.querySelector('[data-rc-nav]');
    var more = root.querySelector('[data-rc-more]');
    var swiperEl = root.querySelector('.rc-swiper');
    var perView = {
      desktop: parseFloat(root.getAttribute('data-rc-desktop')) || 3,
      tablet: parseFloat(root.getAttribute('data-rc-tablet')) || 2,
      mobile: parseFloat(root.getAttribute('data-rc-mobile')) || 1
    };

    window.tstBoot.index(root.getAttribute('data-rc-src')).then(function (items) {
      if (!items.length) {
        if (window.Shopify && Shopify.designMode) {
          root.querySelector('[data-rc-editor-note]').hidden = false;
          root.classList.remove('is-loading');
          if (nav) nav.hidden = true;
        } else {
          root.hidden = true;
        }
        return;
      }

      if (summary) {
        var sum = 0;
        items.forEach(function (item) { sum += parseFloat(item.r) || 0; });
        var average = sum / items.length;
        summary.querySelector('[data-rc-avg]').textContent = average.toFixed(1);
        summary.querySelector('.rc-stars').style.setProperty('--rating', average.toFixed(2));
        summary.querySelector('[data-rc-count]').textContent = items.length.toLocaleString() + ' ' + (items.length === 1 ? root.getAttribute('data-rc-label-one') : root.getAttribute('data-rc-label'));
        summary.classList.add('is-ready');
      }
      if (more) more.hidden = false;

      var picked = choose(
        items,
        root.getAttribute('data-rc-sort'),
        parseFloat(root.getAttribute('data-rc-min')) || 0,
        parseInt(root.getAttribute('data-rc-limit'), 10) || 12
      );
      if (!picked.length) {
        root.hidden = !(window.Shopify && Shopify.designMode);
        return;
      }

      fetchCards(root.getAttribute('data-rc-pick'), picked.map(function (item) { return item.h; })).then(function (cards) {
        if (!cards.length) { root.hidden = !(window.Shopify && Shopify.designMode); return; }
        wrapper.innerHTML = cards.map(function (html) { return '<div class="swiper-slide">' + html + '</div>'; }).join('');
        swiperEl.hidden = false;
        root.classList.remove('is-loading');
        var autoplay = root.getAttribute('data-rc-autoplay') === 'true';
        whenSwiper(function () {
          root.__rcSwiper = new Swiper(swiperEl, {
            slidesPerView: perView.mobile,
            spaceBetween: parseInt(root.getAttribute('data-rc-gap'), 10) || 24,
            speed: 500,
            autoplay: autoplay ? { delay: (parseInt(root.getAttribute('data-rc-delay'), 10) || 4) * 1000, pauseOnMouseEnter: true, disableOnInteraction: false } : false,
            navigation: nav ? { prevEl: nav.querySelector('[data-rc-prev]'), nextEl: nav.querySelector('[data-rc-next]') } : false,
            breakpoints: {
              576: { slidesPerView: perView.tablet },
              992: { slidesPerView: perView.desktop }
            }
          });
        });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rc]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-rc]');
    if (root && root.__rcSwiper) root.__rcSwiper.destroy(true, true);
  });
})();
